// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"259c6681","78":"ef61f41b","91":"26725929","219":"921e6e2e","360":"12fc8b22","508":"f28eeb59","594":"1133fc44","618":"d9d57350","679":"eaf8867a","758":"1d0da02e"}[chunkId] + ".chunk.js";
};